import Breadcrumbs from "@/components/breadcrumb";
import {Layout} from "@/components/layout";
import Container from "@/components/ui/container";
import {Separator} from "@/components/ui/separator";
import {HeadMetadata} from "@/components/headMetadata";
import React from "react";

export default function RadioPage() {
  const breadcrumb = [
    {label: 'Mentions légales' }
  ];

  return (
    <Layout>
      <HeadMetadata
        title="Mentions légales"
        description="Découvrez l'univers de RRB, où la musique rencontre la parole. Explorez nos dernières podcasts, trouvez nos fréquences et partez à la découverte de vos titres préférés."
      />

      <Container>
        <Breadcrumbs entries={breadcrumb}/>

        <h1 className="mb-2 text-[40px] text-foreground-dark">Mentions légales</h1>
        <Separator className="mb-4"/>

        <div className="py-8 flex flex-col gap-4 max-w-[565px] mx-auto">
          <div>
            <strong>Éditeur : </strong>
            <p>
              Ce site est édité par Radio Rythme Bleu<br/>
              Adresse : Rue de Sebastopol, Nouméa 98800, Nouvelle-Calédonie<br/>
              Téléphone : +687254646<br/>
              rrb@lagoon.nc<br/>
              Directeur de la publication : Elizabeth Nouar
            </p>
          </div>

          <div>
            <strong>Réalisation et maintenance :</strong>
            <p>
              Skazy<br/>
              7b rue Gambetta, 98800 Nouméa<br/>
              26.20.69<br/>
              <a href="https://skazy.nc" target="_blank">www.skazy.nc</a>
            </p>
          </div>

          <div>
            <strong>Propriété intellectuelle</strong>
            <p>
              Tous les éléments de contenu du site sont et restent la propriété intellectuelle et exclusive de l&apos;Editeur<br />
              Personne n&apos;est autorisé à reproduire, exploiter, rediffuser, ou utiliser à quelque titre que ce soit, même partiellement, des éléments du site qu&apos;ils soient logiciels, visuels ou sonores.
            </p>
          </div>

          <div>
            <strong>Conditions d&apos;utilisation et responsabilité</strong>
            <p>L&apos;Editeur met en œuvre tous les moyens dont il dispose, pour assurer une information et une mise à jour fiables de son site internet. L&apos;Editeur du site n&apos;est en aucun cas responsable de l&apos;interprétation ou de l&apos;utilisation, ou encore de la réutilisation faite de ces informations, et de tout préjudice direct ou indirect pouvant en découler.</p>
          </div>

          <div>
            <strong>Accessibilité</strong>
            <p>L&apos;Éditeur ainsi que l&apos;hébergeur s&apos;efforcent de permettre aux internautes d&apos;avoir accès en continu au site. Néanmoins, l&apos;Editeur se réserve le droit de ne pouvoir garantir l&apos;accessibilité à son site internet et à l&apos;ensemble des services proposés en cas de force majeur (panne, intention technique de maintenance). La responsabilité de l&apos;Editeur ne pourrait être engagée.</p>
          </div>
        </div>
      </Container>
    </Layout>
  )
}

